export const BUBBLE_DURATION_MS = 5000;
export const DISCUSSION_MODES = ['pre', 'post'];

